<template>
    <section v-if="props.names && props.names.length">
        <h2 class="part-page-heading">{{ $t("PartDetail.ManufacturerAkaHeader", [props.manufacturerName]) }}</h2>
        <div class="panel py-4 px-8 grid grid-cols-[repeat(auto-fit,_minmax(20rem,_1fr))] gap-1">
            <div v-for="name of props.names" :key="name">{{ name }}</div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    names: { type: Array, required: true },
    manufacturerName: { type: String, required: true },
});
</script>
